export interface TakeoverPathParams {
  enduserId: string;
  viewId: string;
  blockId: string;
}

export const CONTACT_DETAILS_TAKEOVER_BASE_PATH = "/contact-details";

export const buildTakeoverPath = ({ enduserId, viewId, blockId }: TakeoverPathParams): string =>
  `${CONTACT_DETAILS_TAKEOVER_BASE_PATH}/${enduserId}/${viewId}/${blockId}`;

export const matchTakeoverPath = (pathname: string): TakeoverPathParams | undefined => {
  const [base, enduserId, viewId, blockId, ...rest] = pathname.split("/").filter(Boolean);

  if (`/${base}` !== CONTACT_DETAILS_TAKEOVER_BASE_PATH) return undefined;
  if (!enduserId || !viewId || !blockId || rest.length) return undefined;

  return { enduserId, viewId, blockId };
};
